var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.accessSetting ? 'container__simple__label' : 'container__simple__denied'},[_c('div',{staticClass:"label-primary"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"sub_title_card"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }